// This function allows you to use a sort of round robin to get an item from an array of items.
// Example:
// const colors = ["red", "green", "blue"];
// const color = extractColor(colors, 0); // red
// const color2 = extractColor(colors, 1); // green

import { IApiUser, IRawUser } from "@propely/propely-typings";

// const color5 = extractColor(colors, 4); // green
export const extractColor = (colors: string[], index: number): string => {
  if (colors.length < 1) {
    throw new Error("No colors provided");
  }

  return colors[index % colors.length];
};

// This function allows you to normalize an array of colors to a specific length.
export const normalizeColorArray = (colors: string[], length: number): string[] => {
  if (colors.length === length) {
    return colors;
  }

  const colorArray = new Array(length).fill(colors[0]);

  return colorArray.map((_, index) => extractColor(colors, index));
};

const colorNames = ["blue", "indigo", "warning", "brand", "error", "success", "purple", "pink", "orange", "green", "red", "yellow"];
const shades = [300, 400, 500, 600, 700];

const simpleHash = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

export const getAvatarColorForUser = (user: IRawUser | IApiUser | undefined): string => {
  return getAvatarColor(user?.id ?? "");
};

export const getAvatarColor = (input: string): string => {
  const hash = simpleHash(input);
  const colorIndex = hash % colorNames.length;
  const shadeIndex = (hash >> 4) % shades.length;
  const colorName = colorNames[colorIndex];
  const shade = shades[shadeIndex];
  return `var(--${colorName}-${shade})`;
};
